// can later be replaced with Intl.ListFormat, when browser support is better
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/ListFormat
export function formatList(list: string[]) {
  if (list.length < 3) {
    return list.join(' and ');
  }
  return `${list.slice(0, -1).join(', ')} and ${list[list.length - 1]}`;
}
